<template>
  <div class="visit-contact-redirect">
    <Loader v-if="loading" />

    <div v-else class="status-wrapper container">
      <div v-if="error" class="status error">
        <p>{{ error }}</p>
      </div>
      <div v-else class="status">
        <p>Redirigiendo al chat...</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiUrls from "@/new-constants/apiUrls";
import Loader from "@/components/Ui/Loader.vue";

export default {
  name: "VisitContactHostRedirect",
  components: {
    Loader,
  },
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  computed: {
    accommodationId() {
      return this.$route.params.accommodationId;
    },
    guestEmail() {
      return this.$route.query.email || null;
    },
    // Normaliza posibles artefactos de codificación como el prefijo "3D"
    normalizedGuestEmail() {
      let email = this.guestEmail || '';
      // Algunos clientes de correo pueden dejar "3D" al inicio por quoted-printable
      if (email.startsWith('3D')) {
        email = email.slice(2);
      }
      // Por si quedara un '=' inicial
      if (email.startsWith('=')) {
        email = email.slice(1);
      }
      return email.trim();
    },
  },
  async created() {
    if (!this.accommodationId || !this.normalizedGuestEmail) {
      this.error = "Faltan datos para crear la conversación (alojamiento o correo del huésped).";
      this.loading = false;
      return;
    }

    try {
      await axios.post(apiUrls.conversationsFromVisitHost, {
        accommodation_id: this.accommodationId,
        guest_email: this.normalizedGuestEmail,
      });

      this.$router.replace({ name: "conversation" });
    } catch (e) {
      console.error(
        "Error al crear la conversación desde la visita (host):",
        (e && e.response) || e
      );
      const backendMessage =
        (e && e.response && e.response.data && e.response.data.message) || null;
      this.error =
        backendMessage ||
        "Ocurrió un error al crear la conversación con tu huésped. Por favor, intenta de nuevo desde tu panel.";
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.visit-contact-redirect {
  position: relative;
  min-height: 60vh;
}

.status-wrapper {
  min-height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status {
  text-align: center;
  font-size: 1rem;
}

.status.error {
  color: #c0392b;
}
</style>
